import {FloatingFocusManager as FloatingUIFocusManager, FloatingPortal} from '@floating-ui/react'
import {useFloatingContext} from '../context'
import {useModalContext} from '~/components/modal/modal_context'
import {useLayoutEffect, useState} from 'react'

export const FloatingFocusManager = ({children, ...rest}) => {
	const {modalRef} = useModalContext() // specifies the root node the portal container will be appended to if we are inside a modal
	const {context, isNested} = useFloatingContext()
	const [root, setRoot] = useState(null)

	useLayoutEffect(() => {
		if (modalRef?.current) {
			setRoot(modalRef.current)
			return
		}

		// old modals do not use the modal context, so we need to query the body element
		// if not found, we fallback to the document body
		const el = document.querySelector('.ant-modal-body')
		setRoot(el || document.body)
	}, [modalRef])

	// ignore initial focus for nested items, otherwise keep default tabbable index as specified by the `order`
	const initialFocus = isNested ? -1 : 0

	return (
		<FloatingPortal root={root}>
			<FloatingUIFocusManager modal={false} {...rest} context={context} initialFocus={initialFocus} returnFocus={!isNested}>
				{children}
			</FloatingUIFocusManager>
		</FloatingPortal>
	)
}
